import { type Pagination } from "@dashboard/types";
import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const atticApiKeysSectionUrlName = "/attic/api-keys";

export const atticApiKeyListPath = `${atticApiKeysSectionUrlName}/`;
export const atticApiKeyAddPath = urlJoin(atticApiKeyListPath, "add");
export const atticApiKeyPath = (id: string) => urlJoin(atticApiKeyListPath, id);
export const atticApiKeyUrl = (id: string) => atticApiKeyPath(encodeURIComponent(id));

/** The list has no filters: a store holds a handful of keys. Paging only. */
export type AtticApiKeyListUrlQueryParams = Pagination;

export const atticApiKeyListUrl = (params?: AtticApiKeyListUrlQueryParams) =>
  atticApiKeyListPath + "?" + stringifyQs(params);
